module.exports = __webpack_public_path__ + "img/281.aa797fcf.jpg";